
import { Component, Vue, Prop } from 'vue-property-decorator'
import HomeMenu from './Menu.vue'

@Component({
  components: {
    HomeMenu
  }
})
export default class extends Vue {
  private units = [
    { title: '中国职工技术协会', icon: require('@/assets/icons/zhigong.png'), url: '', span: 10 },
    { title: '教育部学校规划建设发展中心', icon: require('@/assets/icons/jiaoyubu.png'), url: 'https://csdp.edu.cn/index.aspx?AspxAutoDetectCookieSupport=1', span: 14 },
    { title: '中国职工发展基金会', icon: require('@/assets/icons/jijinh.png'), url: 'https://www.china-wdf.org.cn/', span: 10 },
    { title: '中国继续工程教育协会', icon: require('@/assets/icons/jiaoyu.png'), url: 'http://www.cacee.org.cn/index.html', span: 14 }
  ]

  gotosite (url: string) {
    if (url) {
      window.open(url, '_blank')
    } else {
      window.location.href = '#'
    }
  }
}
